<template>
  <div>
    <div style="display: flex">
      <div style="width: 72%">
        <div style="display: flex;justify-content: space-between">
          <div style="display: flex;flex-direction: column">
            <span>Pieces</span>
            <el-input-number
              :value="cargoDoc.quantity || undefined"
              no="quantity"
              :min="0"
              :max="999999999999"
              :precision="0"
              :disabled="!isEdit"
              controls-position="right"
              :controls="false"
              style="width:120px;margin-right:5px"
              @input="val=>{cargoDoc.quantity=val}"
            />
          </div>
          <div style="display: flex;flex-direction: column">
            <span>Gross Weight</span>
            <el-input-number
              :value="cargoDoc.weight || undefined"
              no="weight"
              :min="0"
              :max="999999999999"
              :precision="3"
              :disabled="!isEdit"
              :controls="false"
              controls-position="right"
              style="width:120px;margin-right:5px"
              @input="val=>{cargoDoc.weight=val}"
              @change="weightChangeHandler;commonChangeHandler('weight')"
            />
          </div>
          <div style="display: flex;flex-direction: column;margin-right: 2px;">
            <span>KG-LB</span>
            <el-select v-model="cargoDoc.kglb" :disabled="!isEdit" no="kglb" style="width: 70px;">
              <el-option label="K" value="K" />
              <el-option label="L" value="L" />
            </el-select>
          </div>
          <div style="display: flex;flex-direction: column;margin-right: 2px;">
            <span>Rate Class</span>
            <el-select v-model="cargoDoc.rateClass" :disabled="!isEdit" no="rateClass" style="width: 70px;" :placeholder="!isEdit ? '' : $t('SeaExport.PleaseSelect')" @change="rateClassChangeHandler">
              <el-option v-for="item in AirExportConstants.RATE_CLASSES" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div style="display: flex;flex-direction: column">
            <span>C.Weight</span>
            <el-input-number
              :value="cargoDoc.cWeight || undefined"
              no="cWeight"
              :min="0"
              :max="999999999999"
              :precision="1"
              :disabled="!isEdit"
              controls-position="right"
              :controls="false"
              style="width:120px;margin-right:5px"
              @input="val=>{cargoDoc.cWeight=val||0}"
              @change="cWeightChangeHandler();commonChangeHandler('cWeight')"
            />
          </div>
          <div style="display: flex;flex-direction: column;width: 100px;margin-right: 2px;">
            <span>Rate Charge</span>

            <cargo-input
              v-model="cargoDoc.rateCharge"
              :disabled="!isEdit"
              no="rateCharge"
              :auto-uppercase="true"
              @change="commonChangeHandler('rateCharge')"
            />
          </div>
          <div style="display: flex;flex-direction: column;width: 100px;">
            <span>Total</span>

            <cargo-input
              v-model="cargoDoc.cTotal"
              :disabled="!isEdit"
              no="cTotal"
              :auto-uppercase="true"
            />
          </div>

        </div>
        <div>
          <div style="display: flex;flex-direction: column;">
            <span>Remark</span>
            <cargo-rich-textarea
              v-model="cargoDoc.remark1"
              no="remark1"
              style="height: 186px;"
              :text-chars="0"
              :auto-uppercase="isUppercaseByConfig"
              :warning-count="-1"
              :disabled="!isEdit"
              @dblclick.native="showAdvanceTextDialog('Remark',cargoDoc.remark1,val=>{cargoDoc.remark1=val})"
            />
          </div>
        </div>
      </div>
      <div style="flex-grow: 1; width: 28%; margin-left: 5px;">
        <div style="display: flex;flex-direction: column">
          <span>Nature and Quantity of Goods</span>
          <cargo-rich-textarea
            v-model="cargoDoc.cargoEnglishName"
            no="cargoEnglishName"
            :disabled="!isEdit"
            :auto-uppercase="isUppercaseByConfig"
            :text-chars="0"
            :warning-count="-1"
            @dblclick.native="showAdvanceTextDialog('Nature and Quantity of Goods',cargoDoc.cargoEnglishName,val=>{cargoDoc.cargoEnglishName=val})"
          />

        </div>
        <div style="display: flex;flex-direction: column">
          <span>Dimension</span>
          <cargo-rich-textarea
            v-model="cargoDoc.dimension"
            no="dimension"
            :disabled="!isEdit"
            :text-chars="0"
            :auto-uppercase="true"
            :warning-count="-1"
            style="height: 110px"
            @dblclick.native="showAdvanceTextDialog('Dimension',cargoDoc.dimension,val=>{cargoDoc.dimension=val})"
          />
        </div>
        <div style="display: flex;flex-direction: column">
          <span>Volume</span>
          <el-input-number
            :value="cargoDoc.cubage || undefined"
            no="cubage"
            :min="0"
            :max="999999999999"
            :precision="3"
            :disabled="!isEdit"
            controls-position="right"
            :controls="false"
            style="width:100%;margin-right:5px"
            @input="val=>{cargoDoc.cubage=val}"
            @change="commonChangeHandler('cubage')"
          />
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div style="margin-right: 5px;">
        <div>
          <div style="display: flex;justify-content: space-around">
            <span>Prepaid</span>
            <span>Weight Charge</span>
            <span>Collect</span>
          </div>
          <div style="display: flex;">

            <cargo-input
              v-model="cargoDoc.pp1"
              no="pp1"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp1=val}"
              @change="commonChangeHandler('PP1')"
            />
            <cargo-input
              v-model="cargoDoc.cc1"
              no="cc1"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.wtVal !== AirExportConstants.CC"
              @input="val=>{cargoDoc.cc1=val}"
              @change="commonChangeHandler('CC1')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Valuation</span>
          </div>
          <div style="display: flex;">

            <cargo-input
              v-model="cargoDoc.pp2"
              no="pp2"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp2=val}"
              @change="commonChangeHandler('PP2')"
            />

            <cargo-input
              v-model="cargoDoc.cc2"
              no="cc2"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.wtVal !== AirExportConstants.CC"
              @input="val=>{cargoDoc.cc2=val}"
              @change="commonChangeHandler('CC2')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Tax</span>
          </div>
          <div style="display: flex;">

            <cargo-input
              v-model="cargoDoc.pp3"
              no="pp3"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp3=val}"
              @change="commonChangeHandler('PP3')"
            />

            <cargo-input
              v-model="cargoDoc.cc3"
              no="cc3"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.wtVal !== AirExportConstants.CC"
              @input="val=>{cargoDoc.cc3=val}"
              @change="commonChangeHandler('CC3')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Total other Charges Due Agent</span>
          </div>
          <div style="display: flex;">

            <cargo-input
              v-model="cargoDoc.pp4"
              no="pp4"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.other !== AirExportConstants.PP"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp4=val}"
              @change="commonChangeHandler('PP4')"
            />

            <cargo-input
              v-model="cargoDoc.cc4"
              no="cc4"
              :auto-uppercase="true"
              :disabled="!isEdit ||cargoDoc.other !== AirExportConstants.CC"
              @input="val=>{cargoDoc.cc4=val}"
              @change="commonChangeHandler('CC4')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center;padding-top:7px; ">
            <span>Total other Charges Due Carrier</span>
          </div>
          <div style="display: flex;justify-content: center;">

            <cargo-input
              v-model="cargoDoc.pp5"
              no="pp5"
              :auto-uppercase="true"
              :disabled="true"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp5=val}"
              @change="commonChangeHandler('PP5')"
            />

            <cargo-input
              v-model="cargoDoc.cc5"
              no="cc5"
              :auto-uppercase="true"
              :disabled="true"
              @input="val=>{cargoDoc.cc5=val}"
              @change="commonChangeHandler('CC5')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: space-around">
            <span>Total prepaid</span>
            <span>Total collect</span>
          </div>
          <div style="display: flex">

            <cargo-input
              v-model="cargoDoc.pp6"
              :disabled="!isEdit"
              no="pp6"
              :auto-uppercase="true"
              style="margin-right: 2px;"
              @change="commonChangeHandler('PP6')"
            />

            <cargo-input
              v-model="cargoDoc.cc6"
              :disabled="!isEdit"
              no="cc6"
              :auto-uppercase="true"
            />
          </div>
        </div>
      </div>
      <div>
        <div>
          <other-charge-grid :cargo-doc="cargoDoc" :action="action" :job="job" />
        </div>
        <div style="padding-top: 7px;">
          <span>Signature of Shipper or his Agent</span>
          <cargo-input
            v-model="cargoDoc.signByShipper"
            :disabled="!isEdit"
            no="signByShipper"
            :auto-uppercase="true"
          />
        </div>
        <div style="display: flex">
          <div style="margin-right: 2px; display: flex; flex-direction: column;">
            <span>Executed on (date)</span>
            <el-date-picker
              v-model="cargoDoc.signDateBL"
              :disabled="!isEdit"
              no="signDateBL"
              :editable="false"
              :clearable="false"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            />
          </div>
          <div style="margin-right: 2px;">
            <span>at (place)</span>

            <cargo-input
              v-model="cargoDoc.signPlaceBL"
              :disabled="!isEdit"
              no="signPlaceBL"
              :auto-uppercase="true"
            />
          </div>
          <div>
            <span>Signature of Issuing Carrier or its Agent</span>

            <cargo-input
              v-model="cargoDoc.signByCarrier"
              :disabled="!isEdit"
              no="signByCarrier"
              :auto-uppercase="true"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" type="primary" no="confirm" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="close"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import OtherChargeGrid from '@/views/cargo/v0/AirImport/components/booking/tabs/OtherChargeGrid'
import { IataPrice } from '@/class/model/sys/IataPrice'
import * as NumberUtils from '@/utils/NumberUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { queryIataPriceCarrier } from '@/api/price/iataPrice'
import { Company } from '@/class/model/mdm/Company'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoInput from '@/components/Cargo/Common/cargoInput'

const states = {
  readonly: 'readonly',
  editing: 'editing'
}
export default {
  name: 'HAWBPart1',
  components: {
    CargoInput,
    cargoRichTextarea, OtherChargeGrid
  },
  props: {
    action: { type: String, default: 'look' },
    cargoDoc: { type: Object },
    job: { type: Object },
    isUppercaseByConfig: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      states: states,
      AirExportConstants,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      iataPrice: null,
      aEcWeightCeil: ''
    }
  },
  computed: {
    isEdit() {
      return this.action !== 'look'
    }
  },
  methods: {
    async fillView() {
      if (!this.cargoDoc.kglb) {
        this.cargoDoc.kglb = 'K'
      }
      if (this.job && (!this.iataPrice || this.iataPrice.pol !== this.job.loadingPortCode || this.iataPrice.pod !== this.job.destinationPortCode)) {
        const cmp = await Company.getCompanyById(this.job.carrierId)
        const carrier = !cmp ? null : cmp.shortName
        queryIataPriceCarrier({ pol: this.job.loadingPortCode, pod: this.job.destinationPortCode, carrier: carrier }).then(res => {
          this.iataPrice = res.data || null
        })
      }
      this.refreshPPCC()
      await cache.load(cacheName.USER, cacheName.OFFICE, cacheName.CONFIG)
      this.aEcWeightCeil = Number(cache.config.get('AEcWeightCeil'))
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    refreshTotal(updateRC = true) {
      const iataPrice = this.iataPrice
      const cargoDoc = this.cargoDoc
      const rc = NumberUtils.parseNumber(cargoDoc.rateCharge)
      if (iataPrice) {
        let level = new IataPrice(iataPrice).getPriceRange(cargoDoc.cWeight)
        if (updateRC) {
          if (level > 0) {
            cargoDoc.rateCharge = NumberUtils.formatNumber(level, 2)
          } else {
            level = rc
          }
        } else { // 兼容直接调整 rateCharge 的情况
          level = NumberUtils.parseNumber(cargoDoc.rateCharge)
        }
        if (isNaN(rc) || cargoDoc.rateClass === 'M') {
          cargoDoc.cTotal = cargoDoc.rateCharge
        } else {
          cargoDoc.cTotal = NumberUtils.formatNumber(this.replaceNaNWithZero(level * cargoDoc.cWeight), 2)
        }
        return
      }
      if (isNaN(rc) || cargoDoc.rateClass === 'M') {
        cargoDoc.cTotal = cargoDoc.rateCharge
      } else {
        let cw = cargoDoc.cWeight
        cw = isNaN(cw) ? 0 : cw
        cargoDoc.cTotal = NumberUtils.formatNumber(cw * rc, 2)
      }
    },
    // 以0替换NaN
    replaceNaNWithZero(num) {
      if (isNaN(num)) {
        return 0
      }
      return num
    },
    // 更新PP,CC值
    refreshPPCC() {
      if (!this.cargoDoc) return
      const cargoDoc = this.cargoDoc
      this.changeWtvalPosition(cargoDoc, 'pp1', 'cc1', cargoDoc.wtVal, cargoDoc.cTotal)
      this.changeWtvalPosition(cargoDoc, 'pp2', 'cc2', cargoDoc.wtVal)
      this.changeWtvalPosition(cargoDoc, 'pp3', 'cc3', cargoDoc.wtVal)
      if (cargoDoc.docType === CargoDocConsts.HAWB) {
        if (!cargoDoc.pp4 && !cargoDoc.cc4 && !cargoDoc.pp5 && !cargoDoc.cc5) {
          cargoDoc.pp4 = 'AS ARRANGED'
        }
        if (!cargoDoc.pp4 && !cargoDoc.cc4) {
          cargoDoc.pp4 = cargoDoc.pp5
          cargoDoc.cc4 = cargoDoc.cc5
          cargoDoc.pp5 = ''
          cargoDoc.cc5 = ''
        }
      }
      this.changeWtvalPosition(cargoDoc, 'pp4', 'cc4', cargoDoc.other)
      this.changeWtvalPosition(cargoDoc, 'pp5', 'cc5', cargoDoc.other)
      this.refreshPPCC6(cargoDoc)
    },
    // 刷新PPCC6
    refreshPPCC6(cargoDoc) {
      const pp1 = !cargoDoc.pp1 ? 0 : NumberUtils.parseNumber(cargoDoc.pp1)
      const pp2 = !cargoDoc.pp2 ? 0 : NumberUtils.parseNumber(cargoDoc.pp2)
      const pp3 = !cargoDoc.pp3 ? 0 : NumberUtils.parseNumber(cargoDoc.pp3)
      const pp4 = !cargoDoc.pp4 ? 0 : NumberUtils.parseNumber(cargoDoc.pp4)
      const pp5 = !cargoDoc.pp5 ? 0 : NumberUtils.parseNumber(cargoDoc.pp5)
      if (!isNaN(pp1) && !isNaN(pp2) && !isNaN(pp3) && !isNaN(pp4) && !isNaN(pp5)) {
        const pp6 = pp1 + pp2 + pp3 + pp4 + pp5
        if (pp6 === 0) {
          cargoDoc.pp6 = ''
        } else {
          cargoDoc.pp6 = NumberUtils.formatNumber(pp6, 2)
        }
      } else if (!isNaN(pp1)) {
        cargoDoc.pp6 = cargoDoc.pp1
        if (cargoDoc.pp6 === 0) {
          cargoDoc.pp6 = ''
        }
      } else {
        if (cargoDoc.pp6 === 0) {
          cargoDoc.pp6 = ''
        }
      }

      const cc1 = !cargoDoc.cc1 ? 0 : NumberUtils.parseNumber(cargoDoc.cc1)
      const cc2 = !cargoDoc.cc2 ? 0 : NumberUtils.parseNumber(cargoDoc.cc2)
      const cc3 = !cargoDoc.cc3 ? 0 : NumberUtils.parseNumber(cargoDoc.cc3)
      const cc4 = !cargoDoc.cc4 ? 0 : NumberUtils.parseNumber(cargoDoc.cc4)
      const cc5 = !cargoDoc.cc5 ? 0 : NumberUtils.parseNumber(cargoDoc.cc5)
      if (!isNaN(cc1) && !isNaN(cc2) && !isNaN(cc3) && !isNaN(cc4) && !isNaN(cc5)) {
        const cc6 = cc1 + cc2 + cc3 + cc4 + cc5
        if (cc6 === 0) {
          cargoDoc.cc6 = ''
        } else {
          cargoDoc.cc6 = NumberUtils.formatNumber(cc6)
        }
      } else if (!isNaN(cc1)) {
        cargoDoc.cc6 = cargoDoc.cc1
        if (cargoDoc.cc6 === 0) {
          cargoDoc.cc6 = ''
        }
      } else {
        if (cargoDoc.cc6 === 0) {
          cargoDoc.cc6 = ''
        }
      }
    },
    changeWtvalPosition(cargoDoc, pp, cc, type, data) {
      if (!data) {
        data = !cargoDoc[pp] ? cargoDoc[cc] : cargoDoc[pp]
      }
      if (type === AirExportConstants.PP) {
        cargoDoc[pp] = data
        cargoDoc[cc] = ''
      } else if (type === AirExportConstants.CC) {
        cargoDoc[cc] = data
        cargoDoc[pp] = ''
      }
    },
    refreshOtherCharge() {
      if (!this.cargoDoc) return
      const cargoDoc = this.cargoDoc
      if (cargoDoc && cargoDoc.other && cargoDoc.otherCharge) {
        let total = 0
        for (const charge of cargoDoc.otherCharge) {
          if (charge.amount && !isNaN(charge.amount)) { total += Number(charge.amount) }
        }
        if (cargoDoc.other === AirExportConstants.PP) {
          if (total !== 0) {
            cargoDoc.pp4 = NumberUtils.formatNumber(total, 2)
          } else {
            cargoDoc.pp4 = ''
          }
          cargoDoc.cc4 = ''
        } else if (cargoDoc.other === AirExportConstants.CC) {
          if (total !== 0) {
            cargoDoc.cc4 = NumberUtils.formatNumber(total, 2)
          } else {
            cargoDoc.cc4 = ''
          }
          cargoDoc.pp4 = ''
        }
      }
    },
    wtValChanged(str = '') {
      this.refreshPPCC()
    },
    otherChanged(str = '') {
      const oldValue = this.cargoDoc.pp5 ? this.cargoDoc.pp5 : this.cargoDoc.cc5
      if (str === AirExportConstants.PP) {
        this.cargoDoc.pp5 = oldValue
      } else if (str === AirExportConstants.CC) {
        this.cargoDoc.cc5 = oldValue
      }
      this.refreshOtherCharge()
      this.refreshPPCC()
    },
    weightChangeHandler() {
      if (this.cargoDoc) {
        const c = this.cargoDoc.otherCharge
        for (const charge of c) {
          if (charge.measure === 'wt' && charge.unitRate > 0) {
            charge.amount = (isNaN(charge.unitRate) ? 0 : charge.unitRate) * (isNaN(this.cargoDoc.weight) ? 0 : this.cargoDoc.weight)
          }
        }
        this.refreshOtherCharge()
        this.refreshPPCC()
      }
    },
    cWeightChangeHandler() {
      if (this.cargoDoc) {
        const c = this.cargoDoc.otherCharge
        if (c) {
          for (const charge of c) {
            if (charge.measure === 'chargeWeight' && charge.unitRate > 0) {
              charge.amount = (isNaN(charge.unitRate) ? 0 : charge.unitRate) * (isNaN(this.cargoDoc.cWeight) ? 0 : this.cargoDoc.cWeight)
            }
          }
        }
        if (this.cargoDoc.cWeight === 0) {
          this.cargoDoc.rateCharge = ''
          this.cargoDoc.cTotal = ''
          this.cargoDoc.rateClass = ''
          this.refreshPPCC()
        } else {
          this.refreshOtherCharge()
          this.refreshPPCC()
        }
      }
    },
    totalChargeHandler() {
      if (this.iataPrice) {
        const cargoDoc = this.cargoDoc
        const w = isNaN(cargoDoc.cWeight) ? 0 : cargoDoc.cWeight
        const level = isNaN(new IataPrice(this.iataPrice).getPriceRange(w)) ? 0 : new IataPrice(this.iataPrice).getPriceRange(w)
        cargoDoc.rateCharge = NumberUtils.formatNumber(level, 2)
        const t = level * w
        if (t < this.iataPrice.levelM) {
          if (w === 0) {
            cargoDoc.rateClass = ''
          } else {
            cargoDoc.rateClass = 'M'
          }
          cargoDoc.cTotal = cargoDoc.rateClass
        } else {
          if (w >= 0 && w < 45) {
            cargoDoc.rateClass = 'N'
          } else if (w >= 45) {
            cargoDoc.rateClass = 'Q'
          }
          cargoDoc.cTotal = NumberUtils.formatNumber(level * w, 2)
        }
      }
      this.refreshPPCC()
    },
    rateClassChangeHandler() {
      if (this.iataPrice && this.cargoDoc.docType === 'MBL') {
        if (this.cargoDoc.rateClass === 'M') {
          this.cargoDoc.cTotal = NumberUtils.formatNumber(this.iataPrice.levelM, 2)
          this.cargoDoc.rateCharge = NumberUtils.formatNumber(this.iataPrice.levelM, 2)
        } else {
          const level = new IataPrice(this.iataPrice).getPriceRange(this.cargoDoc.cWeight)
          const t = level * (isNaN(this.cargoDoc.cWeight) ? 0 : this.cargoDoc.cWeight)
          if (t < this.iataPrice.levelM) {
            this.$message.warning(this.$t('queryJob.TheRateMAndAdjusted'))
            return
          }
          this.cargoDoc.rateCharge = NumberUtils.formatNumber(level, 2)
          this.cargoDoc.cTotal = NumberUtils.formatNumber(t, 2)
        }
      } else {
        if (this.cargoDoc.rateClass === 'M') {
          this.cargoDoc.cTotal = this.cargoDoc.rateCharge
        } else {
          this.refreshTotal()
        }
      }
      this.refreshPPCC()
    },
    async fillModel() {
      await cache.load(cacheName.USER, cacheName.OFFICE, cacheName.CONFIG)
      if (Number(cache.config.get('airCargoEnglishName')) === 2) {
        this.job.cargoEnglishName = this.cargoDoc.cargoEnglishName
      }
      if (Number(cache.config.get('airCargoMark')) === 2) {
        this.job.mark = this.cargoDoc.remark1
      }
      if (!this.cargoDoc.kglb) {
        this.cargoDoc.kglb = 'K'
      }
      if (CargoDocConsts.HAWB === this.cargoDoc.docType && !this.cargoDoc.pp4 && !this.cargoDoc.cc4 && !this.cargoDoc.pp5 && !this.cargoDoc.cc5) {
        if (this.cargoDoc.wtVal === AirExportConstants.PP) {
          this.cargoDoc.pp4 = 'AS ARRANGED'
        } else {
          this.cargoDoc.cc4 = 'AS ARRANGED'
        }
      }
      if (CargoDocConsts.HAWB === this.cargoDoc.docType && !this.cargoDoc.pp4 && !this.cargoDoc.cc4) {
        this.cargoDoc.cc4 = this.cargoDoc.cc5
        this.cargoDoc.pp4 = this.cargoDoc.pp5
      }
    },
    commonChangeHandler(type = '') {
      const cargoDoc = this.cargoDoc
      const prop = cargoDoc.docType === CargoDocConsts.HAWB ? this.job.pbProportion : this.job.pbProportion2
      switch (type) {
        case 'weight' :
        case 'cubage' :
          if (!(this.job.lob === 'AE')) {
            cargoDoc.cWeight = JobUtils.calcChargeWeight(cargoDoc.weight, cargoDoc.cubage)
          }
          cargoDoc.cWeight = JobUtils.calcProportion(prop, cargoDoc.weight, cargoDoc.cubage, cargoDoc.docType !== CargoDocConsts.HAWB, this.aEcWeightCeil)
          this.$emit('chargeWeightChange')
          this.refreshTotal()
          this.refreshPPCC()
          break
        case 'cWeight' :
          if (cargoDoc && (cargoDoc.docType === CargoDocConsts.HAWB || cargoDoc.docType === CargoDocConsts.HAWB2)) {
          } else {
            cargoDoc.cWeight = JobUtils.calcChargeWeight2(cargoDoc.cWeight, true, this.aEcWeightCeil)
          }
          if (cargoDoc.docType === 'HBL' && cargoDoc.rateCharge === 'AS ARRANGED') {
            cargoDoc.cTotal = 'AS ARRANGED'
          }
          this.$emit('chargeWeightChange')
          break
        case 'rateCharge' :
          this.refreshTotal(false)
          this.refreshPPCC()
          if (cargoDoc.docType === 'HAWB' && cargoDoc.rateCharge === 'AS ARRANGED') {
            cargoDoc.cTotal = 'AS ARRANGED'
          }
          break

        case 'PP1' :
        case 'CC1' :
        case 'PP5' :
        case 'CC5' :
          this.refreshPPCC()
          break
        case 'PP2' :
        case 'CC2' :
        case 'PP3' :
        case 'CC3' :
        case 'PP4' :
        case 'CC4' :
          this.refreshPPCC6(cargoDoc)
          break
        case 'PP6':
          this.refreshPPCC6(cargoDoc)
          break
        default :
          break
      }
    }
  }
}
</script>

<style scoped>

</style>
